<script setup lang="ts">
import { onMounted, shallowRef } from 'vue';
import { formatCompanyInfo } from '@/modules/agreements/utils';
import { useCompaniesStore } from '@/store/companies-store';
import { Data, PbCompanyInfo } from '@/connect';

const props = defineProps<{
  displayId: string;
  label: string;
  tabindex?: string;
}>();

const company = shallowRef<Data<PbCompanyInfo> | null>(null);

onMounted(() => {
  company.value = useCompaniesStore().getCompany(props.displayId) ?? null;
});
</script>

<template>
  <VTextField
    v-if="company"
    :label="label"
    readonly
    :tabindex="tabindex"
    :value="formatCompanyInfo(company)"
  />
</template>

<style lang="scss" scoped></style>
